import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useParams } from "react-router-dom"
import { getScheduleRecordId } from "library/get-unique-id-from-tree.mjs"
import { getTreeId } from "routes/schedule/lib/getTreeId"
import { getRegimeScheduleComments } from "routes/schedule/plugins/share-link-comments/share-link-comments.controller"
import { isShareLinkContentOverrideEnabled } from "routes/schedule/plugins/share-link-comments/share-link-content-overrides-feature-flag"

const EMPTY = []

// Auto-justification text for the schedule introduction (or its notes) from any share-link comments
// anchored there, so the justification box can be pre-populated. `part` is "content" or "note". Mirrors
// useTaskShareLinkCommentReason, but matches intro anchors (path ["intro","content"] / ["intro","note"])
// rather than task anchors. Returns "" when the feature is off or there are none.
export function useIntroShareLinkCommentReason(part) {
    const enabled = isShareLinkContentOverrideEnabled()
    const { schedule, schedulePath, currentId } = useBoundContext()
    const { id: routeSchedulePath } = useParams()
    const activeSchedulePath = schedulePath ?? currentId ?? routeSchedulePath
    const regimeId = enabled && activeSchedulePath ? getTreeId(activeSchedulePath) : null
    const scheduleId = enabled ? (activeSchedulePath ? getScheduleRecordId(activeSchedulePath) : schedule?.id) : null
    const comments = getRegimeScheduleComments.useResults({ regimeId, scheduleId }) ?? EMPTY

    if (!enabled) return ""
    return comments.filter(matches).map(toLine).join("\n")

    function matches(comment) {
        const anchor = comment?.anchor ?? {}
        if (anchor.type !== "intro") return false
        const anchorPart = anchor.path?.[1] ?? anchor.part ?? "content"
        return anchorPart === part
    }

    function toLine(comment) {
        const name = comment.authorName ?? "a share-link reviewer"
        const date = `${comment.created ?? ""}`.slice(0, 10)
        const text = `${comment.body ?? ""}`.trim()
        return `Addressed share-link recommendation from ${name}${date ? ` on ${date}` : ""}: "${text}"`
    }
}
